import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Tag.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Feedback extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    generate({ slug, text } = {}) {
        if (!slug) {
            throw new ArgumentError('[Model][Feedback] slug is mandatory');
        }
        return BaseAPIModel.fetcher
            .post(`/target/feedback/${slug}`, {
                data: {
                    text
                }
            })
            .then(response => Boolean(response.ok));
    }

    static listUrl({ slug }) {
        if (!slug) {
            throw new ArgumentError('[Model][Feedback] slug is mandatory');
        }
        return `/target/feedback/${slug}`;
    }
}
